import { render } from "./MaterialAlert.vue?vue&type=template&id=25feb8fa&scoped=true"
import script from "./MaterialAlert.vue?vue&type=script&lang=js"
export * from "./MaterialAlert.vue?vue&type=script&lang=js"

import "./MaterialAlert.vue?vue&type=style&index=0&id=25feb8fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25feb8fa"]])

export default __exports__